import React from "react";
import { object, string } from "prop-types";
import { Link } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../../atoms/Headline";
import PublishedAt from "../../atoms/PublishedAt";

import "./customStoryCard10.m.css";

const CustomStoryCard10 = ({ story, className = "", publisherAttributes }) => {
  const subHeadlineStyle = `${publisherAttributes.lang}-sub-headline`;
  const sentTime = story.created_time + " GMT";

  return (
    <div styleName={`base ${publisherAttributes.lang === "en" ? "en-base" : ""}`} className={className}>
      <div styleName="wrapper">
        <div styleName="story-data">
          <PublishedAt date={new Date(sentTime.toLocaleString())} className="notification-storydate" />
          <Link href={story.notification_url}>
            <Headline text={story.notification_title} headerLevel={2} headlineType={27} className="headline" />
          </Link>
          {story.notification_message ? (
            <Headline
              text={story.notification_message}
              headerLevel={4}
              headlineType={6}
              className="sub-headline"
              styleName={subHeadlineStyle}
            />
          ) : null}
        </div>
        {story.notification_image && (
          <Link href={story.notification_url}>
            <img src={story.notification_image} />
          </Link>
        )}
      </div>
    </div>
  );
};

CustomStoryCard10.propTypes = {
  story: object.isRequired,
  className: string,
  publisherAttributes: object
};

const mapStateToProps = state => {
  return {
    isLoading: get(state, ["pageLoading"], false),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

export default connect(mapStateToProps, null)(CustomStoryCard10);
